/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { ChecklistSchema } from "../types/ChecklistSchema";

type Response = {
  payload: ChecklistSchema;
};

export const useChecklist = (project_id: string) => {
  const api = useApi();
  const [data, setData] = useState<ChecklistSchema | null>(null);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api.get(`/projectget_checklist_by_project_id?project_id=${project_id}`)
    .then((res: SuccessFetch<Response>) => setData(res?.data?.payload ?? null))
    .catch(() => setData(null))
    .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(null);
      setLoading(false);
    };
  }, []);

  return { data, isLoading, refetch };
}
